module.exports = __webpack_public_path__ + "static/media/third.a034b65e.svg";